import { useState, useEffect } from 'react';
import css from './ContractOverview.module.css';

import * as contractServices from '../../../../services/contractService';
import ContractsTable from './ContractsTable';
import AddContract from './AddContract';
import Overlay from '../../_common/elements/Overlay';
// import CourseList from './CourseList';
// import CourseOptions from './CourseOptions';

function ContractOverview() {
    const [contracts, setContract] = useState([]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        let page;
        contractServices
            .getAll(page || 1)
            .then((result) => {
                // console.log(result);
                setContract((state) => result.data.sort((a, b) => b.contractId - a.contractId) || []);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const onAdd = (e, newData) => {
        e.preventDefault();

        contractServices
            .create(newData)
            .then((res) => {
                console.log(res);
                let updatedData = {...newData, contractId: res.insertId}
                setContract((state) => [updatedData, ...state]);
                handleShowModal();
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const handleShowModal = (e) => {
        // e.stopPropagation();
        setShowModal((st) => !st);
    };

    return (
        <div className={css.main}>
            <div>
                <ContractsTable data={contracts} onAdd={onAdd} service={contractServices} showModal={handleShowModal} />
                {showModal && (
                    <Overlay>
                        <AddContract onAdd={onAdd} onClose={handleShowModal} />
                    </Overlay>
                )}
            </div>
            {/* <div>
        <AddContract data={contracts} />

      </div> */}
        </div>
    );
}

export default ContractOverview;
